// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32Ekt","title":"styles_title__1WKng"};